import script from "./MessageItemReadOnly.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageItemReadOnly.vue?vue&type=script&lang=ts&setup=true"

import "./MessageItemReadOnly.vue?vue&type=style&index=0&id=786172d8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786172d8"]])

export default __exports__